import {WorkerCoordinate} from "../../../types/coordinates/worker-coordinate";
import {CoordinateListDto} from "../../../types/coordinates/worker-coordinate-dto";

export const mapToCoordinate = (
    listDto: CoordinateListDto
): WorkerCoordinate[] => {
    return listDto.coordinates.map((dto) => {
        return {
            workerName: dto.workerName,
            longitude: dto.longitude,
            latitude: dto.latitude,
            scheduleId: dto.scheduleId,
        }
    });
};
